<div data-testid="pos-shift-close-page" class="p-6 flex-table-page">
  <!-- Header -->
  <h2 class="text-2xl font-semibold text-gray-800 mb-3 flex-table-header">
    {{ "pos.shift_close.management.title" | translate }}
  </h2>

  <app-search-form
    data-testid="pos-shift-close-search-form"
    [searchFormat]="searchConfig"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions" class="flex gap-2">
      <app-button
        [testId]="'pos-shift-close-column-config-btn'"
        type="success"
        [outlined]="true"
        icon="view_column"
        (emitOnClick)="onColumnConfigClick($event)"
      ></app-button>
      <app-status-filter></app-status-filter>
    </div>
  </app-search-form>

  <!-- Data Table -->
  <div class="flex-table-section">
    <advanced-data-table
      data-testid="pos-shift-close-table"
      #advancedTable
      [dataSource]="posShiftClosings()"
      [defaultColumns]="defaultColumns()"
      [flexibleColumns]="flexibleColumns()"
      [loading]="loading()"
      [totalRecords]="totalRecords()"
      [rows]="searchParams().size"
      [first]="searchParams().page * searchParams().size"
      [hasCheckColumn]="false"
      scrollHeight="flex"
      (pageChange)="onPageChange($event)"
      [showInternalColumnConfigButton]="false"
    >
    <!-- Custom Status Template -->
    <ng-template #statusTemplate let-status>
      <div class="flex items-center justify-center gap-1">
        <p-tag
          data-testid="pos-shift-close-status-tag"
          [value]="getStatusDisplayText(status)"
          [severity]="getStatusSeverity(status)"
          styleClass="status-tag"
          [ngStyle]="getStatusStyle(status)"
          [pTooltip]="getStatusDisplayText(status)"
          tooltipPosition="top"
          tooltipStyleClass="custom-tooltip"
          [showDelay]="300"
          [hideDelay]="0"
        />
      </div>
    </ng-template>

    <!-- Custom Template for different column types -->
    <ng-template
      #customTemplate
      let-value
      let-column="column"
      let-rowData="rowData"
    >
      @if (column.template === "dateTemplate") {
        <span class="text-xs text-gray-600">
          {{ formatDateTime(value) }}
        </span>
      } @else if (column.template === "currencyTemplate") {
        <span class="text-xs text-gray-600 text-right">
          {{ formatCurrency(value) }}
        </span>
      }
    </ng-template>

    <!-- Custom Actions Template -->
    <ng-template #actionsTemplate let-rowData>
      <div class="flex gap-2 justify-center">
        @if (canRead()) {
          <app-button
            [testId]="'pos-shift-close-action-view'"
            class="action-view"
            [label]="'common.actions.view' | translate"
            type="action"
            (emitOnClick)="onView(rowData)"
          ></app-button>
        }
      </div>
    </ng-template>
    </advanced-data-table>
  </div>
</div>

<p-toast data-testid="pos-shift-close-toast"></p-toast>
